import { formatAmount } from '@chaos/ui/utils/formatters';

export const rangeErrorMsg = (value: number, min: number, max: number) => {
  const isOutOfRange = value < min || value > max;
  if (!isOutOfRange) return undefined;
  return `Value must be between ${formatAmount(min, { notation: 'standard' })} and ${formatAmount(max, { notation: 'standard' })}`;
};
